import React from 'react'
import { FormattedNumber } from 'react-intl'
import padStart from 'lodash/padStart'
import { type MetricData } from 'legacy/components/DataViz/dataViz.types'

interface Props {
  dataType: MetricData['data_type']
  value: number | null
}

const NUMBER_FORMATS = {
  currency: 'currency',
  percent: 'percent',
  number: 'decimal',
  count: 'decimal',
} as const

function secondsToTimeString(totalSeconds: number) {
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = Math.floor(totalSeconds) % 60

  return `${minutes}:${padStart(seconds.toString(), 2, '0')}`
}

const MetricValue: React.FunctionComponent<Props> = ({ dataType, value }) => {
  if (value === null) {
    // eslint-disable-next-line react/jsx-no-literals
    return <>-</>
  }

  if (dataType === 'seconds') {
    return <>{secondsToTimeString(value)}</>
  }

  const format = NUMBER_FORMATS[dataType]

  return (
    <FormattedNumber
      value={value}
      style={format}
      minimumFractionDigits={value < 0.1 ? 1 : 0}
      maximumFractionDigits={format === 'decimal' ? 2 : undefined}
      currency="USD"
    />
  )
}

export default MetricValue
